import config from "../../config"
import RequestService from "../RequestService"

const fetchProjects = (successCallback, failureCallback) => {
  RequestService.get(`${config.backendUrl}/projects`, successCallback, failureCallback)
}

export default fetchProjects;